// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_9H_","cls2":"ReportList-cls2_l7r ReportList-cls1_9H_"};